import * as $ from 'jquery';

export const init = (container:any) => {
    let animateContainer = $('.load-container').clone().removeClass('d-none');
    container.append(animateContainer);
};